import React, { createContext, PropsWithChildren, useMemo } from "react";
import useMeasure from "utils/hooks/useMeasure";
import { MIN_CARD_WIDTH } from "features/bots/MyBots/BotsCards";

const CardsLayoutProvider = ({ children }: PropsWithChildren) => {
  const [measureRef, { width }] = useMeasure<HTMLDivElement>(undefined, 25);

  let numRowItems = Math.floor(width / MIN_CARD_WIDTH);
  if (width < 700) numRowItems = 1;
  else if (width < 1450) numRowItems = 2;
  else if (width < 2000) numRowItems = 3;
  const estimatedCardSize = (width - (numRowItems - 1) * 16) / numRowItems - 32;

  const contextValue = useMemo(() => {
    return {
      pageWidth: width,
      numRowItems,
      estimatedCardSize,
    };
  }, [width, numRowItems, estimatedCardSize]);

  return (
    <CardsLayoutContext.Provider value={contextValue}>
      <div style={{ height: "100%", width: "100%" }} ref={measureRef}>
        {children}
      </div>
    </CardsLayoutContext.Provider>
  );
};

export default CardsLayoutProvider;

export const CardsLayoutContext = createContext<
  | {
      pageWidth: number;
      numRowItems: number;
      estimatedCardSize: number;
    }
  | undefined
>(undefined);
